import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const TableMenu = () => (
  <ComponentDocs
    name="<Table.Menu/>"
    entry="MenuCell"
    propsEntry="MenuCellProps"
    namespace="TableCells"
  >
    <ComponentExample
      name="Table menu"
      import={import("examples/Tables/TableMenu/TableMenuExample")}
      rawImport={import("examples/Tables/TableMenu/TableMenuExample?raw")}
    />
    <ComponentExample
      name="Hoverable menu"
      description="A table menu can open when it is hovered over with an optional close delay. The hoverable prop on the table column can also be used to only show the menu when the table row is hovered over."
      import={import("examples/Tables/TableMenu/HoverableMenuExample")}
      rawImport={import("examples/Tables/TableMenu/HoverableMenuExample?raw")}
    />
    <ComponentExample
      name="Custom trigger"
      import={import("examples/Tables/TableMenu/CustomTriggerExample")}
      rawImport={import("examples/Tables/TableMenu/CustomTriggerExample?raw")}
    />
  </ComponentDocs>
);

export default TableMenu;
